export default __webpack_public_path__ + "static/media/Brigand's Belt of a Hundred Eyes.a37316c2.jpg";